
/* injects from baggage-loader */

'use strict';

import { findIndex, clone } from 'lodash';

import regions from './tab-book.const';

import _ from 'lodash';

const initialState = {
    activeTab: 0,
    page: 0,
    pagination: 4
};

export default class tabBookController {
    constructor($log, $rootScope, $timeout, $location) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$location = $location;
        
        this.state = clone(initialState);

        this.auxItems = [];

        this.sequence = [];
        
    }

    $onInit(){
        this.setRegion();

        this.aux = this.selecionaOpcao();

        this.$rootScope.$on('tabdevice:drop:success', angular.bind(this, this.onDropSuccess));
        this.$rootScope.$on('reset:stage', angular.bind(this, this.onReset));
        this.$rootScope.$on('reset2:stage', angular.bind(this, this.onReset2));

        this.$rootScope.$on('correctItems', (event, data) => {
            this.auxItems = data;
        });

        this.$rootScope.$on('stage:state', (event, data) => { 
            this.sequence = data;
        });
    }

    setRegion(){
        this.tabs = regions[this.region].tabs;
        this.device = regions[this.region].device;
        this.book = regions[this.region].book;
        this.title = regions[this.region].title;
        this.description = regions[this.region].description;
        this.typeReg = regions[this.region].type;
    }
    
    getCurrentTab(){
        return this.tabs[this.state.activeTab];
    }

    setCurrentTab(index){
        this.state.activeTab = index;
        this.state.page = 0;
        if(this.typeReg === 1){
            this.$rootScope.$emit('setCurrentTab',index);
        }
    }

    onDropSuccess(event, data){
        let indexOf = findIndex( this.getCurrentTab().items, { title: data.title })
        // select item dropped
        if(indexOf >= 0) {
            this.getCurrentTab().items[indexOf].selected = true;
        } else {
            return false;
        }
    }

    
    togglePagination(){
        return this.state.page ? this.state.page = 0 : this.state.page = 1
    }

    // modificando o comportamento dos resets

    //reseta só os itens errados quando recebe o sinal 1
    onReset(){
        this.state = clone(initialState);

        let locale = this.$location.url();

        switch (locale){
            case "/main/stage-one":
                this.resetaUnico();
                break;
            case "/main/stage-two":
                this.onReset2();
                break;
            case "/main/stage-three":
                this.resetaUnico();
                break;
            default:
                this.resetaVarios();
                break;
        }

        
    }

    //reseta tudo quando recebe o sinal 2 
    onReset2(){
        this.state = clone(initialState);

        this.tabs.map( tab => {
            tab.items.map( item => {
                delete item.selected;
                return item;
            });
            return tab;
        });
    }

    //reseta quando os pedidos são 1 de cada categoria
    resetaUnico(){
        this.tabs.map( (tab, outerIndex) => {
            tab.items.map( item => {
                if(this.auxItems[outerIndex] !== undefined){
                    if (item.title !== this.auxItems[outerIndex].title){
                        delete item.selected;
                    }
                }
                return item;
            });
            return tab;
        });
    }

    //reseta quando os pedidos são vários em cada categoria
    resetaVarios(){

        let qtd = _.countBy(this.sequence);     //contando quantos pratos de cada tipo o estagio pede
        let aux = [];                           //vai virar uma matriz com a mesma estrutura do objeto acima
        let cont = 0;                           //contador pra auxiliar a posicionar corretamente os itens

        //criando o array auxiliar
        for (let i = 0; i < 4; i++){
            aux[i] = [];

            for (let j = 0; j < qtd[i+1]; j++){
                aux[i][j] = 1;
            }
        }

        //preenchendo o array auxiliar
        for (let i = 0; i < aux.length; i++){
            for (let j = 0; j < aux[i].length; j++){
                aux[i][j] = this.auxItems[cont];
                cont++;
            }
        }

        //pra cada tipo de item
        this.tabs.forEach((tab, outer) => {
            //pra cada quantidade de item
            tab.items.forEach(item => {

                //auxiliar pra conferir se um prato foi encontrado
                let flags = [];

                //checa o prato correto pra cada item 
                for (let i = 0; i < aux[outer].length; i++){
                    //se o prato correto existir
                    if (aux[outer][i] !== undefined){
                        //se o título for diferente do esperado, seta uma flag pra ser apagado
                        if (aux[outer][i].title !== item.title){
                            flags[i] = false;
                        }
                        //se for igual, seta que não seja
                        else {
                            flags[i] = true;
                        }
                    }
                    //se não existir
                    else{
                        flags[i] = false;
                    }
                }

                //faz um sort do array de flags pra que caso exista true ele seja o primeiro item
                let sorted = flags.sort(function(x, y) { return y - x });

                //se não tiver um true lá, apaga o item
                if (sorted[0] === false){
                    delete item.selected;
                }

            });
        });


    }
    
    // seleciona no máximo 4 pratos caso existam mais que isso
    selecionaOpcao(){                                  
        let result = []

        this.tabs.forEach(tab => {
            let tamanho = tab.items.length;
            if (tamanho > 4){
                let a = _.sampleSize(tab.items, 4);
                result.push(a);
            }
            else{
                result.push(tab.items);
            }
        });  

        //envia os pratos
        this.$rootScope.$emit('selecaoPratos', result);

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-book/tab-book.controller.js